import { FormDateInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames';

export function OcrDateRangeEditableLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        layout,
        onChange,
        ...props
    }
) {
    const [ , errors, validate] = useValidation();
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

    const col1Title = layout.table.columns[0].columnTitle;
    const col2Title = layout.table.columns[1].columnTitle;

    useEffect(() => {
        initializeDateRange();
        validateLayout();
    }, [layout]);

    function initializeDateRange() {
        if (layout?.table?.rows && layout.table.rows.length > 0) {
            const row = layout.table.rows[0];
            if (row.length > 1) {
                setDateRange({
                    startDate: row[0],
                    endDate: row[1]
                });
            }
        }
    }

    function validateLayout() {
        const required = layout.requiredAnswerCount > 0;
        const rules = [
            { fieldName: 'startDate', required: required },
            { fieldName: 'endDate', required: required }
        ];
        validate(rules, dateRange);
    }

    function onStartDateChange(value) {
        const updatedDateRange = {
            ...dateRange,
            startDate: value ? moment(value).format("YYYY-MM-DD") : null
        };
        setDateRange(updatedDateRange);
        updateLayout(updatedDateRange);
    }

    function onEndDateChange(value) {
        const updatedDateRange = {
            ...dateRange,
            endDate: value ? moment(value).format("YYYY-MM-DD") : null
        };
        setDateRange(updatedDateRange);
        updateLayout(updatedDateRange);
    }

    function updateLayout(updatedDateRange) {
        const clonedLayout = { ...layout };
        clonedLayout.table = {
            ...layout.table,
            rows: [[updatedDateRange.startDate, updatedDateRange.endDate]]
        };
        onChange(clonedLayout);
    }

    return (
        <Fragment>
            <div className={classNames('form-row field-combination')}>

                <div className={classNames({ "hide-in-print": !readonly, "hidden": readonly })}>
                    <h4>{layout.secondaryLayoutTitle}</h4>
                    <FormDateInput
                        loading={loading}
                        onChange={onStartDateChange}
                        value={dateRange.startDate ? moment(dateRange.startDate).toString() : null}
                        headingText={col1Title}
                        disabled={disabled}
                        dangerHelperText={errors.startDate}
                    />
                    <FormDateInput
                        loading={loading}
                        onChange={onEndDateChange}
                        value={dateRange.endDate ? moment(dateRange.endDate).toString() : null}
                        headingText={col2Title}
                        disabled={disabled}
                        dangerHelperText={errors.endDate}
                    />
                </div>
                <div className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading })}>
                    <h4>{layout.secondaryLayoutTitle}</h4>
                    <div className="form-field">
                        <span>
                            {moment(dateRange.startDate).format("DD/MM/YYYY")} - {moment(dateRange.endDate).format("DD/MM/YYYY")}
                        </span>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

OcrDateRangeEditableLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};